export default "__VITE_ASSET__C82IFdXG__"